var app = angular.module("leonardo");

var ExportUsersDialog = function($scope, NotificationService, AccountUserService, FormErrorsService) {

  $scope.emails = 1;
  $scope.filters = $scope.ngDialogData.filters ? $scope.ngDialogData.filters : {};

  $scope.emails_send = [];
  if (AccountUserService.currentAccountUser && AccountUserService.currentAccountUser.user)
    $scope.emails_send.push(AccountUserService.currentAccountUser.user.email);
  else
     $scope.emails_send.push(AuthService.user.email);

  $scope.getNumber = function(num) {
    return new Array(num);
  };

  $scope.emailsError = function() {
    if (!$scope.Form.$submitted) return false;
    else if ($scope.emails_send.length === 0) return true;
    else {
      var error = true;
      angular.forEach($scope.emails_send, function(value){
        if (value)
          error = false;
      });
      return error;
    }
  };

  $scope.export = function() {
    $scope.Form.$setSubmitted();
    if ($scope.emailsError()) return;
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }

    $scope.filters.response_email_recipients = $scope.emails_send.join(',');

    AccountUserService.exportAccountUsers($scope.filters).then(function () {
      NotificationService.notify('success', 'An email will be sent to you in a few moments.');
      $scope.closeThisDialog();
    }, function(){
      $scope.closeThisDialog();
    });
  };

};

app.controller('ExportUsersDialog', ['$scope', 'NotificationService', 'AccountUserService', 'FormErrorsService', ExportUsersDialog]);